module.exports = __webpack_public_path__ + "img/product2.9fdfdfd1.png";